<template>
    <v-timeline align-top dense>
        <v-timeline-item
            color="primary"
            small
            fill-dot
        >
            <template #icon>
                <span class="white--text font-weight-bold">1</span>
            </template>
            <div class="pb-3">
                <div class="font-weight-medium mb-1">Create a Customized Order Confirmation Form</div>
                <div class="text-body-2 text--secondary">
                    Using a template with your branding applied, design a customized form where customers can review and confirm their order details.
                </div>
            </div>
        </v-timeline-item>

        <v-timeline-item
            color="primary"
            small
            fill-dot
        >
            <template #icon>
                <span class="white--text font-weight-bold">2</span>
            </template>
            <div class="pb-3">
                <div class="font-weight-medium mb-1">Publish the Form</div>
                <div class="text-body-2 text--secondary">
                    Once you're happy with your form, publish it. You can edit and republish at any time.
                </div>
            </div>
        </v-timeline-item>

        <v-timeline-item
            color="primary"
            class="pb-0"
            small
            fill-dot
        >
            <template #icon>
                <span class="white--text font-weight-bold">3</span>
            </template>
            <div>
                <div class="font-weight-medium mb-1">Configure Your Automated Message</div>
                <div class="text-body-2 text--secondary">
                    Create your customized automated message that includes a link to the order confirmation form, sent to customers after they place an order.
                </div>
            </div>
        </v-timeline-item>
    </v-timeline>
</template>

<script>
export default {
    name: 'OrderConfirmationExplainerSteps',
};
</script>